import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { academylist, certificatelist, certificateupload, listevent } from "../../../services/admin";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { stuacademicyearlist, stuclasslist, studivisionlist } from "../../../services/master";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

export default function CertificateUpload() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [events, setEvents] = useState("");
    const [aclist, setACList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [ayear, setAYear] = useState("");
    const [alist, setAList] = useState([]);

    const [stucls, setStuCls] = useState("");
    const [clist, setCList] = useState([]);

    const [stusec, setStuSec] = useState("");
    const [seclist, setSecList] = useState([]);

    const [certlist, setCertList] = useState([]);

    useEffect(() => {
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setACList(arr);
                }
            }
        });

        stuclasslist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].class_name,
                        });
                    }
                    setCList(arr);
                }
            }
        });

        studivisionlist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].name,
                        });
                    }
                    setSecList(arr);
                }
            }
        });

        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                                listyear(arr[0]);
                                listcert(arr[0])

                            }
                        }

                    }
                }
            });
        } else {
            listyear("");
            listcert("");
        }

    }, []);

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 100,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a title="Download Certificate" href={require("../../../assets/images/certificate.jpeg")} target="_blank"
                            className="btn-sm btn-info me-2"
                        >
                            <i className="fa fa-download"></i>
                        </a>
                      
                    </div>
                );
            },
        },
        {
            headerName: "Username",
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Student Name",
            field: "student_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },

        },
        {
            headerName: "Class",
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },

        },
        {
            headerName: "Section",
            field: "section_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

        {
            headerName: "Year",
            field: "year",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Prize",
            field: "prize",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
        } else {
            setAcaID("");
        }
    }
    const [errmsg, setErrMsg] = useState("");
    function downloadSampleExcel() {
        setErrMsg("");
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                setErrMsg("Please Select Academy");
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }

        let aid = "";
        if (
            localStorage.getItem("Role") === "1" &&
            acaid !== ""
        ) {
            aid = acaid.value;
        }

        if (valid === "") {
            if (ayear !== "") {
                if (stucls !== "") {
                    if (stusec !== "") {
                        window.open(
                            localStorage.getItem("activeBaseUrl")  +
                            "/studentcertificteexcel/" +
                            aid +
                            "/" +
                            ayear +
                            "/" +
                            stucls +
                            "/" +
                            stusec,
                            "_blank"
                        );
                    } else {
                        setErrMsg("Please Select Section");
                    }
                } else {
                    setErrMsg("Please Select Class");
                }
            } else {
                setErrMsg("Please Select Year");
            }

        }
    }

    function listyear(aid) {
        setAList([]);
        setAYear("");
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid.value);
        }
        stuacademicyearlist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].aca_year,
                        });
                    }
                    setAList(arr);
                }
            }
        });
    }

    const [photoerror, setPhotoError] = useState("");
    const [pfile, setPFile] = useState("");
    function photofile(event) {
        setPhotoError("");
        setPFile("");
        if (event.target.files.length !== 0) {
            if (event.target.files[0].name.match(/\.(xls|xlsx)$/i)) {
                setPFile(event.target.files[0]);
            } else {
                setPhotoError("Upload Excel should be xls or xlsx format");
            }
            var size = event.target.files[0].size / 1024 / 1024;
            if (size > 5) {
                setPhotoError("Upload Excel size should be less than 5MB");
            }
        }
    }

    function listcert(aid) {
        setCertList([]);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid.value);
        }

        listevent(temp).then((res) => {
            if (res.status === true) {
                if (res.data.details.length > 0) {
                    const ddata = res.data.details
                        .find((item) => item.id == id)
                    
                    setEvents(ddata.event_name);
                }
            }
        })

        certificatelist(temp).then((res) => {
            if (res.status === true) {
                setCertList(res.data.details);
            }
        })
    }

    const [show, setShow] = useState(false);
    function handleShow() {
        setStuCls("");
        setStuSec("");
        setAYear("");
        setShow(true);
    }

    function handleClose() {
        setShow(false);
        setStuCls("");
        setStuSec("");
        setAYear("");
    }

    function handleUpload(e) {
        e.preventDefault();
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                toast.error("Please Select Academy")
                valid = "Please Select Academy";
            }
        }

        if (valid === "") {
            if (pfile !== "") {
                const temp = new FormData();
                temp.append('academy_id', acaid.value);
                temp.append('excel_name', pfile)
                certificateupload(temp).then((res) => {
                    if (res.status === true) {
                        toast.success(res.data.message)
                        listcert()
                    } else {
                        toast.error(res.message)
                    }
                })
            } else {
                toast.error("Please Select Upload File")
            }
        }
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Certificate List</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Certificate</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                    Certificate List
                    </li>
                </ol>
            </div>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title text-center text-success">{events}</h4>
                            <div className="row">
                                <div className="col-xl-12 text-right">
                                    <a
                                        className="btn btn-danger"
                                        onClick={handleShow}
                                    >
                                        Download Sample Excel
                                    </a>
                                </div>
                                {localStorage.getItem("Role") === "1" && (
                                    <div className="col-xl-4">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Select Academy{" "}
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Academy"
                                                value={acaid}
                                                options={aclist}
                                                onChange={handleAcademy}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>

                                )}
                                <div className="col-xl-6">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Upload Excel{" "}
                                            <span className="text-danger"> *</span>
                                        </label>
                                        <input type="file" className="form-control" accept=".xlsx, .xls" onChange={(e) => photofile(e)} />
                                        {photoerror && (
                                            <span className="text-danger">{photoerror}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="col-xl-2 text-right">
                                    <a onClick={handleUpload}
                                        className="btn btn-success mt-5 me-2"
                                    >
                                        Submit
                                    </a>
                                    <a onClick={() => navigate(-1)}
                                        className="btn btn-secondary mt-5"
                                    >
                                        Back
                                    </a>
                                </div>

                            </div>

                            <div className="ag-theme-alpine ag-style mt-2">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={certlist}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={["asc", "desc"]}
                                    suppressDragLeaveHidesColumns={true}
                                />
                            </div>

                        </div>
                    </div>


                    <Modal show={show} size="lg" centered onHide={handleClose}>
                        <Modal.Header>
                            <Modal.Title>Download Excel </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">

                                {localStorage.getItem("Role") === "1" && (
                                    <div className="col-xl-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Select Academy{" "}
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Academy"
                                                value={acaid}
                                                options={aclist}
                                                onChange={handleAcademy}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>

                                )}
                                <div className="col-xl-6">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Academic Year{" "}
                                            <span className="text-danger"> *</span>
                                        </label>
                                        <select
                                            className="default-select  form-control wide"
                                            onChange={(e) =>
                                                setAYear(e.target.value)
                                            }
                                            value={ayear}
                                        >
                                            <option value="" disabled>
                                                Select Academic Year
                                            </option>
                                            {alist.map((item) => (
                                                <option value={item.value} key={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Class <span className="text-danger"> *</span>
                                        </label>
                                        <select
                                            className="default-select  form-control wide"
                                            onChange={(e) => setStuCls(e.target.value)}
                                            value={stucls}
                                        >
                                            <option value="" disabled>
                                                Select Class
                                            </option>
                                            {clist.map((item) => (
                                                <option value={item.value} key={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="mb-3">
                                        <label className="form-label">
                                            Section <span className="text-danger"> *</span>
                                        </label>
                                        <select
                                            className="default-select  form-control wide"
                                            onChange={(e) => setStuSec(e.target.value)}
                                            value={stusec}
                                        >
                                            <option value="" disabled>
                                                Select Section
                                            </option>
                                            {seclist.map((item) => (
                                                <option value={item.value} key={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {errmsg !== "" && (
                                    <div className="col-xl-12">
                                        <span className="text-danger">
                                            {errmsg}
                                        </span>
                                    </div>
                                )}
                            </div>

                        </Modal.Body>
                        <Modal.Footer>

                            <div className="text-right">
                                <a
                                    className="btn btn-secondary me-2"
                                    onClick={() => downloadSampleExcel()}
                                    target="_blank"
                                >
                                    Download Sample Excel
                                </a>

                                <a
                                    className="btn btn-danger"
                                    onClick={() => handleClose()}
                                >
                                    Close
                                </a>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );


}
